// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6262b8c6","977":"a7ff5792"}[chunkId] + ".chunk.js";
};